import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import { STORE_NAME, AlertStorage } from './private';

const initialState: AlertStorage = [];

export const slice = createSlice({
    name: STORE_NAME,
    initialState,
    reducers,
});

export default slice.actions;
